module.exports = __webpack_public_path__ + "img/head3.1fd98748.png";